<template>
  <div style="display: flex;height: 100%">
    <v-col class="resize">
      <router-link to="login">
        <img src="../../assets/svg/login.svg" class="centerImage">
      </router-link>
    </v-col>
    <v-col>
      <div>
        <div class="center" style="margin-top: 30px">
          <span class="spanTitle"> ایجاد شرکت</span>
        </div>
        <div style="margin-top: 20px;">
          <div>
            <img src="../../assets/svg/personal.svg" style="width: 24.17px">
            <span style="margin-right: 5px">اطلاعات شخصی مدیر</span>
            <v-divider style="margin-top: 10px"></v-divider>
          </div>
          <div class="spaceBetween">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">نام مدیر </span>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">نام خوانوادگی مدیر </span>
            </v-col>
          </div>
          <div class="spaceBetween">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <v-text-field
                  v-model="managerName"
                  :error-messages="errors.managerName"
                  outlined
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="5"
                md="5"
            >
              <v-text-field
                  v-model="managerFamily"
                  :error-messages="errors.managerFamily"
                  outlined
              ></v-text-field>
            </v-col>
          </div>
          <div class="spaceBetween">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">شناسه ملی شرکت</span>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">موبایل </span>
            </v-col>
          </div>
          <div class="spaceBetween">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <v-text-field
                  v-model="national_id"
                  :error-messages="errors.national_id"
                  outlined
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="5"
                md="5"
            >
              <v-text-field
                  v-model="mobile"
                  :error-messages="errors.mobile"
                  outlined
              ></v-text-field>
            </v-col>
          </div>
        </div>
        <div style="margin-top: 20px;">
          <div>
            <img src="../../assets/svg/detailCompany.svg" style="width: 24.17px">
            <span style="margin-right: 5px">مشخصات شرکت</span>
            <v-divider style="margin-top: 10px"></v-divider>
          </div>
          <div class="spaceBetween">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">نام شرکت</span>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">تلفن شرکت</span>
            </v-col>
          </div>
          <div class="spaceBetween">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <v-text-field
                  v-model="company_name"
                  :error-messages="errors.company_name"
                  outlined
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="5"
                md="5"
            >
              <v-text-field
                  v-model="phone"
                  :error-messages="errors.phone"
                  outlined
              ></v-text-field>
            </v-col>
          </div>
          <div class="spaceBetween ">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">کد سازمان</span>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">آدرس</span>
            </v-col>
          </div>
          <div class="spaceBetween">
            <v-col
                cols="12"
                sm="5"
                md="5"
            >
              <v-text-field
                  outlined
                  :error-messages="errors.organizationCode"
                  v-model="organizationCode"
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <v-textarea
                  auto-grow
                  outlined
                  rows="1"
                  row-height="15"
                  :error-messages="errors.address"
                  v-model="address"
              ></v-textarea>
            </v-col>
          </div>
          <div class="spaceBetween ">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">استان</span>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">شهر</span>
            </v-col>
          </div>
          <div class="spaceBetween">
            <v-col
                cols="12"
                sm="6"
                md="5">
              <v-autocomplete
                  :items="provinces"
                  v-model="provinceId"
                  outlined
                  :error-messages="errors.province"
                  color="black"
                  item-value="id"
                  item-text="title"
                  label="یک استان را انتخاب کنید"
              ></v-autocomplete>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="5">
              <v-autocomplete
                  :items="city"
                  v-model="cityId"
                  color="black"
                  :error-messages="errors.city"
                  outlined
                  item-value="id"
                  item-text="title"
                  :disabled="provinceId === ''"
                  label="یک شهر را انتخاب کنید"
              ></v-autocomplete>
            </v-col>
          </div>
          <div class="spaceBetween ">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">تاریخ انقضای پروانه</span>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <span style="font-size: 14px;color: #6C7F96">انتخاب پایانه</span>
            </v-col>
          </div>
          <div class="spaceBetween">
            <v-col
                cols="12"
                sm="6"
                md="5"
            >
              <v-text-field
                  outlined
                  append-icon="mdi-calendar-range"
                  class="custom-input"
                  placeholder="انتخاب تاریخ"
                  v-model="date_license_expiration"
                  :error-messages="errors.date_license_expiration"
              ></v-text-field>
              <date-picker custom-input=".custom-input" v-model="date_license_expiration"></date-picker>
            </v-col>
            <v-col
                cols="12"
                sm="5"
                md="5"
            >
              <v-autocomplete
                  :items="terminals"
                  v-model="terminal_id"
                  outlined
                  :error-messages="errors.terminal_id"
                  color="black"
                  item-value="id"
                  item-text="name"
                  label="یک پایانه را انتخاب کنید"
              ></v-autocomplete>
            </v-col>
          </div>
          <div  style="display: flex;justify-content: center;align-items: center;" class="col-10">
            <v-btn
                color="primary"
                width="180px"
                elevation="2"
                @click="registerCompany()"
            >ثبت شرکت
            </v-btn>
          </div>
        </div>
      </div>
    </v-col>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios";
import Vue from "vue";
import convertDate from "@/plugins/convertDate";
export default {
  name: "registerCompany.vue",
  data(){
    return {
      terminal_id : '',
      date_license_expiration : '',
      provinceId : '',
      organizationCode : '',
      address : '',
      managerName : '',
      managerFamily : '',
      cityId : '',
      national_id : '',
      mobile : '',
      errors : [],
      city : '',
      company_name : '',
      phone : '',
      expire_at : '',
       terminals : [],
      provinces : []
    }
  },
  methods:{
    registerCompany(){
      axiosApi().post('v2/company/register',{
        organizationCode: this.organizationCode,
        company_name: this.company_name,
        national_id: this.national_id,
        managerName: this.managerName,
        managerFamily: this.managerFamily,
        mobile: this.mobile,
        phone: this.phone,
        address: this.address,
        terminal_id: this.terminal_id,
        province: this.provinceId,
        city: this.cityId,
        date_license_expiration: convertDate(this.date_license_expiration)
      }).then(()=>{
        Vue.$toast.open({
          message : "شرکت با موفقیت ایجاد شد و پس از تایید ادمین قابل دسترس خواهد بود.",
          type : "success"
        })
        location.replace('/auth/login')
      }).catch((e)=>{
        this.errors = e.response.data.errors
      })
    },
    getDetailRegister(){
      axiosApi().get('registerDetail')
      .then(({data} )=>{
        this.terminals = data.data.terminals
        this.provinces = data.data.provinces
      })
    }
  },
  watch: {
    provinceId() {
      let code = this.provinces.filter((event) => {
        return event.id === this.provinceId
      })
      axiosApi().post('getCities', {
        code: code[0]['code']
      })
          .then((result) => {
            this.city = result.data.data.city
          })
    }
  },
  mounted() {
    this.getDetailRegister()
  }
}
</script>

<style scoped>
.resize {
  background-color: rgba(250, 248, 253, 1);
  width: 50%;
}

.centerImage {
  display: block;
  margin: auto;
  width: 65%;
  position: sticky;
  top: 10%;
}
.spaceBetween{
  display: flex;
}
.spanTitle{
  font-size: 22px;font-weight: 500;line-height: 28px;text-align: right;color: #6C7F96;
}
@media only screen and (max-width: 780px) {
  .resize{
    display: none;
    width: 40%;
  }

  .resizeForm{
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
}
@media only screen and (max-width: 600px) {
  .resize{
    display: none;
    width: 0;
  }
  .imageMobile{
    display: block;
    height: 200px;
  }

  .resizeForm{
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
}

</style>
